import { triggerTracking } from '@zoopla/tracking';
import { SharingCategory } from './ListingSharing';

const TRACKING_EVENT = 'GAEvent';
const TRACKING_CATEGORY_LISTING_DETAILS = 'listing details';

export const trackFacebookShare = (
    listingId: string,
    category?: SharingCategory
) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: category || TRACKING_CATEGORY_LISTING_DETAILS,
        eventValue: Number(listingId),
        eventAction: 'click to share',
        eventLabel: 'facebook'
    });
};

export const trackTwitterShare = (
    listingId: string,
    category?: SharingCategory
) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: category || TRACKING_CATEGORY_LISTING_DETAILS,
        eventValue: Number(listingId),
        eventAction: 'click to share',
        eventLabel: 'twitter'
    });
};

export const trackClipboardShare = (
    listingId: string,
    category?: SharingCategory
) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: category || TRACKING_CATEGORY_LISTING_DETAILS,
        eventValue: Number(listingId),
        eventAction: 'click to share',
        eventLabel: 'copy link'
    });
};

export const trackWhatsAppShare = (
    listingId: string,
    category?: SharingCategory
) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: category || TRACKING_CATEGORY_LISTING_DETAILS,
        eventValue: Number(listingId),
        eventAction: 'click to share',
        eventLabel: 'whatsapp'
    });
};
